module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.916a4dfc.mp3";